// extracted by mini-css-extract-plugin
export default {"container":"UserBio_container__rKmNo","section":"UserBio_section__zrQ9C","details":"UserBio_details__NUb7P"};